export default {
  title: "Page non trouvée",
  description: `La page que vous recherchez a peut-être été supprimée, a changé de
              <br /> nom ou est temporairement indisponible.`,
};
